import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    tokenList: [],
  },
  actions: {
    async init({ commit }) {
      try {
        let response = await this.$http.get(`/getToken`)
        commit("SET_TOKEN_LIST", response.data)
      } catch (error) {
        console.log(error.toString())
      }
    },
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_TOKEN_LIST(state, payload) {
      state.tokenList = payload
    },
  },
  getters: {
    isLoading: (state) => () => {
      return state.loading
    },
    getToken: (state) => (system) => {
      return state.tokenList.find((item) => item.system == system).token
    },
    getSystemList: (state) => () => {
      return state.tokenList.map((item) => item.system)
    },
    getDeployList: (state) => () => {
      return state.tokenList.map((item) => ({
        system: item.system,
        serverurl: item.deploycheck.serverurl,
        frontendpage: item.page.frontendurl,
        backendpage: item.page.backendurl,
      }))
    },
  },
})
